export default "/build/dist/2c130c8772b5ce37.js"